module.exports = "https://dev.stanwinstonschool.com/predator.c4c8becbe670c1490318966f9795988f.jpg";